<template>
  <div class="min-h-[75dvh] ">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Redirecciones de la Transacción
      </h1>
    </div>

    <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
      <p class="text-gray-600 text-sm xl:text-base mb-2">
        Se configuran las URLs de las páginas de respuesta para cuando una
        transacción es aprobada o pendiente. Estos campos no son obligatorios, y
        en caso de no especificar una URL, se redireccionará a la página de
        respuesta por defecto de WEE!
      </p>

      <div class="flex items-center gap-4 justify-between mb-4">
        <div>
          <h5 class="text-sm xl:text-lg font-semibold flex items-center">
            Si la compra es exitosa, tus usuarios serán dirigidos a:
          </h5>
        </div>
        <div class="flex flex-col items-center">
          <code
            class="text-xs xl:text-sm bg-gray-100 p-2 rounded text-green-600 mb-1"
          >
            Ejemplo: https://sb-wee.ar/v1/success
          </code>
          <small class="text-[0.6rem] text-gray-400 italic">
            Tus pagadores regresarán a esta página al finalizar el proceso del
            pago
          </small>
        </div>
      </div>
      <div class="flex items-center gap-4 justify-between mb-2">
        <div>
          <h5 class="text-sm xl:text-lg font-semibold flex items-center">
            Si la compra queda pendiente, tus usuarios serán dirigidos a:
          </h5>
        </div>
        <div class="flex flex-col items-center">
          <code
            class="text-xs xl:text-sm bg-gray-100 p-2 rounded text-yellow-600 mb-1"
          >
            Ejemplo: https://sb-wee.ar/v1/pending
          </code>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RedireccionesTransaccion",

  data() {
    return {};
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
